// Auth0 provider info
export const AUTH0_DOMAIN = "rkd.auth0.com";
export const CLIENT_ID = "884GSOls7uR20SdquZqbkqUvjYS4UGno";
export const ROLE_KEY = "http://one.rkd.io/role";
export const USER_METADATA = "http://one.rkd.io/user_metadata";
